import { render, staticRenderFns } from "./WaiBuGongShi2.vue?vue&type=template&id=f034b83e&scoped=true&"
import script from "./WaiBuGongShi2.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi2.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi2.vue?vue&type=style&index=0&id=f034b83e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f034b83e",
  null
  
)

export default component.exports